import * as Yup from "yup";
import i18n from "../i18n";

export const ExternalHelpConfigSchema = Yup.object({
  file: Yup.mixed()
    .required(i18n.language === "en" ? "File is required" : "الملف مطلوب")
   ,
});
